import { getRequest } from '../services/requestHandler';
import { HeadWeightLocationDto } from '../models';

export const getHeadWeightLocations = async () => {
  const url = 'headWeight/getHeadWeightLocations?useCache=false';
  const response = await getRequest<HeadWeightLocationDto>('GetHeadWeightLocations', url);
  // TODO: Remove this from here and implement uuid
  let autoId = 0;
  let locations = response.map((r) => {
    return { ...r, headWeightLocationId: autoId++ };
  });
  return locations;
};
